import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

import NProgress from 'nprogress';

// Configuration
NProgress.configure({
	easing: 'ease',
	showSpinner: false,
	speed: 300,
});

// Events
export const LoadingContext = React.createContext(null);

export const LoadingProvider = ({ children }) => {
	const router = useRouter();

	// Hooks
	useEffect(() => {
		router.events.on('routeChangeStart', onRouteStart);
		router.events.on('routeChangeComplete', onRouteComplete);
		router.events.on('routeChangeError', onRouteError);
		return () => {
			router.events.off('routeChangeStart', onRouteStart);
			router.events.off('routeChangeComplete', onRouteComplete);
			router.events.off('routeChangeError', onRouteError);
		};
	}, [router]);

	// Methods
	const onRouteStart = (url, { shallow }) => {
		if (shallow) return;
		NProgress.start();
	};

	const onRouteComplete = (url, { shallow }) => {
		if (shallow) return;
		NProgress.done();
	};

	const onRouteError = (err, url, { shallow }) => {
		if (shallow) return;
		NProgress.done();
	};

	// Render
	return <LoadingContext.Provider value={null}>{children}</LoadingContext.Provider>;
};

// Docs
// https://www.npmjs.com/package/nprogress
